import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useEngine } from "@/engine/store";

const HOME_BY_ROLE = {
  PARTNER: "/partenaire",
  COMPANY: "/entreprise",
  CLIENT: "/espace-client/VSL01-26-014",
  CENTRAL: "/admin",
};

export const Phase3Gate = ({ role, children }) => {
  const { user } = useAuth();
  const engine = useEngine();
  if (user === null || engine.backendLoading || !engine.backendReady) {
    return (
      <div data-testid="phase3-session-loading" className="flex min-h-screen items-center justify-center bg-ivory text-navy">
        <Loader2 className="h-7 w-7 animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/acces-phase3" replace />;
  if (user.role !== role) return <Navigate to={user.redirect_to || HOME_BY_ROLE[user.role] || "/"} replace />;
  if (engine.backendError) {
    return <div data-testid="phase3-load-error" className="p-8 text-center text-sm text-red-700">{engine.backendError}</div>;
  }
  return children;
};